import React, { ReactNode } from 'react';

import { Box, Paper, Stack, Typography } from '@mui/material';

type StatColour = 'primary' | 'success' | 'error' | 'info';

interface StatCardProps {
  label: string;
  value: ReactNode;
  caption: ReactNode;
  icon: ReactNode;
  colour: StatColour;
  footer?: ReactNode;
}

function HeroPlannerDebugStatCard({ label, value, caption, icon, colour, footer }: StatCardProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%', borderLeft: 4, borderLeftColor: `${colour}.main` }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <Box>
          <Typography variant="overline" color="text.secondary">
            {label}
          </Typography>
          <Typography variant="h4" component="p" color={`${colour}.main`} fontWeight="bold">
            {value}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {caption}
          </Typography>
        </Box>
        <Box color={`${colour}.main`} display="flex">
          {icon}
        </Box>
      </Stack>
      {footer && <Box mt={1.5}>{footer}</Box>}
    </Paper>
  );
}

export default HeroPlannerDebugStatCard;
